// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({

  palette: {
    primary: {
      main: '#1d1f63',
    },
    background: {
      default: '#eeeeff'
    }
  },

  typography: {
    h1: {
      fontSize: '26px',
    },
    h2: {
      fontSize: '20px',
    },
    h3: {
      fontSize: '20px',
    },
    h4: {
      fontSize: '18px',
    },
    h5: {
      fontSize: '16px',
    },
    h6: {
      fontSize: '14px',
    },
  },
});

theme.components = {
  MuiCssBaseline: {
    styleOverrides: {
      '.activeMenu': {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      // inline-field (classe pour bpmn-js DefaultFlowProps)
      '.inline-field > div': {
        paddingBottom: '0 !important',
      },
      '.inline-field > div > div': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '10px',
      },
      '.inline-field > div > div label': {
        marginLeft: '0px',
        whiteSpace: 'nowrap',
        order: 2,
      },
      '.inline-field > div > div input[type="number"]': {
        width: '70px',
        order: 1,
      },
    },
  },
  MuiBadge: {
    styleOverrides: {
      badge: {
        transition: 'none !important',
        animation: 'none !important',
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        '--unstable_DataGrid-headWeight': 'bold',
        '--DataGrid-containerBackground': '#fff',
        '& .MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        '& .MuiDataGrid-cell:focus-within': {
          outline: 'none'
        },
        '.MuiDataGrid-row': {
          'cursor': 'pointer'
        },
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      sizeSmall: {
        padding: '2px 8px',
        lineHeight: '1.3',
      },
    },
  },
};

export default theme;
